import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useProfileRestriction } from '@/components/ProfileRestriction/useProfileRestriction';
import { ROUTE_HOME } from '@/router/routes';

export const SubscriptionGate: React.FC = () => {
  const { isRestricted } = useProfileRestriction();

  if (isRestricted) {
    return <Navigate to={ROUTE_HOME} replace />;
  }

  return <Outlet />;
};
